export default __webpack_public_path__ + "static/media/car.0b86ef95.svg";